import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'
import Img from './Img'
import HexPattern from './HexPattern'
import clsx from 'clsx'

export default function ImageAndTextSections({
	pretitle,
	_rawContent,
	sections,
	flipped,
	_key,
}) {
	return (
		<section id={`section-${_key}`}>
			{_rawContent && (
				<header className="ctnr-sm padding [&_h2]:h0 grid gap-4 text-balance !pb-12 text-center">
					{pretitle && <p className="technical-lg">{pretitle}</p>}
					<SanityBlock body={_rawContent} />
				</header>
			)}

			{sections?.map((section, key) => (
				<Section
					{...section}
					imageOnRight={flipped ? key % 2 !== 0 : key % 2 === 0}
					key={key}
				/>
			))}
		</section>
	)
}

function Section({ title, subtitle, _rawBody, link, image, imageOnRight }) {
	return (
		<article className="relative mx-auto my-16 grid max-w-screen-2xl items-center md:grid-cols-2">
			<figure className="self-stretch grayscale">
				<Img className="h-full" {...image} />
			</figure>

			<div
				className={clsx(
					'relative z-[1] grid max-w-[670px] gap-8 bg-ft-gray-light/80 p-12',
					'md:my-8 md:px-[7rem] <md:!order-1 <md:m-4 <md:!-mt-20 <md:px-8',
					'[&_h3]:technical-lg [&_h3]:text-xl',
					imageOnRight
						? 'md:-order-1 md:ml-auto md:translate-x-20'
						: 'md:-translate-x-20',
				)}
			>
				{title && <h3>{title}</h3>}
				{subtitle && <p>{subtitle}</p>}
				<SanityBlock body={_rawBody} />
				<CTALink {...link} />
			</div>

			<HexPattern
				className={clsx(
					'<md:bottom-0 <md:left-0',
					imageOnRight
						? 'md:left-0 md:top-1/2 md:-translate-y-1/2'
						: 'md:bottom-8 md:right-0 md:-scale-x-100',
				)}
			/>
		</article>
	)
}
